export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "prev": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous slide"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next slide"])}
      },
      "de": {
        "prev": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorheriger Slide"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächster Slide"])}
      }
    }
  })
}
